import { IContactFormDataForAPI, IContactPayloadForAPI } from 'src/utils/CommonHelpers/ContactAPIOperations/types';
import {
  addCalendarFields,
  addHomePropertyFields,
  addOccupantFields,
  addRealtorFields,
  addServiceManagerFields,
  addServiceProviderFields,
  addFieldsForUsersThatNeedACompanyName,
  createBasePayload,
} from 'src/utils/CommonHelpers/ContactAPIOperations/sharedContactPayloadBuilderHelpers';
import { UserRole } from 'src/SharedCustomHooks/UseSuiteActions/types';

const buildSuitesPayload = (
  formData: IContactFormDataForAPI,
  propertyId: string,
  suiteId: string,
  adminUser: any,
  allRoles: UserRole[] | null | undefined
): IContactPayloadForAPI => {
  let payload: Partial<IContactPayloadForAPI> = createBasePayload(
    formData,
    adminUser.id,
    allRoles,
    'Suites'
  );
  
  payload = addServiceProviderFields(payload, formData);
  payload = addHomePropertyFields(payload, formData);
  payload = addRealtorFields(payload, formData);
  payload = addOccupantFields(payload, formData);
  payload = addServiceManagerFields(payload, formData);
  payload = addCalendarFields(payload, formData);
  payload = addFieldsForUsersThatNeedACompanyName(payload, formData)
  
  if (formData.userRole === 'Home Owner') {
    // Remove Properties array to avoid backend "Clear and Recreate" logic.
    delete payload.Properties;
    
    // Add singular PropertyId and SuiteId for Suite page submissions.
    payload.PropertyId = propertyId;
    payload.SuiteId = suiteId;
    payload.IsPrimaryContact = formData.isPrimaryContact || false;
  }
  
  delete payload.isPrimaryPropertyDeveloperContact;
  
  return payload as IContactPayloadForAPI;
}

export {
  buildSuitesPayload
}